import React from "react";

import { Box, Button, Chip } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    flexWrap: "wrap",
    minWidth: 0,
    padding: theme.spacing(1, 1.5),
    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.72)}`,
    [theme.breakpoints.down("xs")]: {
      flexWrap: "nowrap",
      overflowX: "auto",
      padding: theme.spacing(0.75, 1),
      ...theme.scrollbarStylesSoft,
    },
  },
  chip: {
    flexShrink: 0,
    maxWidth: 320,
  },
  clearButton: {
    flexShrink: 0,
    marginLeft: theme.spacing(0.25),
  },
}));

const AppliedFiltersBar = ({
  filters = [],
  onRemove,
  onClearAll,
  ariaLabel = "Filtros aplicados",
  clearLabel = "Limpar todos",
  className = "",
}) => {
  const classes = useStyles();
  const visibleFilters = filters.filter(
    (filter) => filter && filter.key != null && filter.label,
  );

  if (visibleFilters.length === 0) {
    return null;
  }

  return (
    <Box
      role="group"
      aria-label={ariaLabel}
      className={`${classes.root} ${className}`.trim()}
    >
      {visibleFilters.map((filter) => (
        <Chip
          key={filter.key}
          className={classes.chip}
          size="small"
          label={filter.label}
          title={filter.label}
          onDelete={() =>
            filter.onRemove ? filter.onRemove(filter.key) : onRemove?.(filter.key)
          }
        />
      ))}
      {onClearAll && visibleFilters.length > 1 ? (
        <Button
          className={classes.clearButton}
          size="small"
          color="primary"
          onClick={onClearAll}
        >
          {clearLabel}
        </Button>
      ) : null}
    </Box>
  );
};

export default AppliedFiltersBar;
